import React from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { fadeInLeft, fadeInRight } from "../../utility/framerAnimations";
import './LendingPartnerSection.css';

const LendingPartnerHeroSection = () => {
    const { t } = useTranslation('lenderPage');
    
    return (
        <Container>
        <section className='section-container'> 
            <div className='lender-hero-section'>
                <motion.div 
                    className="left-lender-hero-section"
                    variants={fadeInLeft}
                    initial="hidden"
                    animate="visible"
                >
                    <div className="left-lender-hero-section-content">
                    Meet Our <span> RBI-Registered</span> Lending Partners
                        <p>We collaborate with trusted financial institutions registered with the Reserve Bank of India to provide you with safe and transparent loan services.</p>
                    </div> 
                </motion.div>
                        
                <motion.div 
                    className="right-lender-hero-section"
                    variants={fadeInRight}
                    initial="hidden"
                    animate="visible"
                >
                    <div className="right-lender-hero-section-content">
                        <img src="/images/bankIMG.png" alt="Bank Building" />
                    </div>
                </motion.div> 
            </div>    
        </section>
        </Container>
    );
};

export default LendingPartnerHeroSection;
